export const environment = {
  production: true,
  websiteUrl: 'https://accendilucegas.it',
  api: {
    basePath: 'https://attiva.accendilucegas.it/api',
    login: 'api@algonboarding.loc',
    secret: 'j8WWe42hzmfreJCN',
    phpBackendUrl: 'https://attiva.accendilucegas.it/',
  },
  documents: {
    _baseUrl: 'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it',
    informativeNote: 'ACCENDI-privacy/Nota-informativa-PRIVACY.pdf',
    informativeNotePrivacy: 'ACCENDI-privacy/Nota-Informativa-Privacy-1.pdf',
    privacyResearch: 'ACCENDI-privacy/Nota-Informativa-Privacy-ricerca.pdf',
    privacySale: 'ACCENDI-privacy/Nota-Informativa-Privacy-vendita.pdf',
    promoRegulation: 'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/promo',
  },
  imageUrl: 'https://attiva.accendilucegas.it/uploads/images/',
  attivazioneUrl: 'https://attiva.accendilucegas.it/uploads/activations/toFill/',
  attivazioneUrl2: 'http://localhost:5000',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts